/**
 * @generated SignedSource<<e8a7a817f4d738a3c524ae4cb9d4c73b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type MarketPlaceProviders = "APP_SUMO" | "CASA_DE_LAS_CARCASAS" | "FAVORITE_GIFT" | "HP" | "MICROSOFT_AZURE" | "VERSORI";
export type variantsQuery$variables = Record<PropertyKey, never>;
export type variantsQuery$data = {
  readonly ecommerceSettings: {
    readonly ecommerceName: ECommerce;
  } | null;
  readonly generalSettings: {
    readonly isSideImageScalingEnabled: boolean;
  };
  readonly salesChannels: ReadonlyArray<{
    readonly ecommerceSettings: {
      readonly definitiveUrl: string | null;
      readonly ecommerceID: number;
      readonly ecommerceName: ECommerce;
      readonly hasProductsApi: boolean;
      readonly isMarketplace: boolean;
      readonly remoteUrl: string | null;
    } | null;
    readonly id: string;
  }>;
  readonly seller: {
    readonly marketplace: MarketPlaceProviders | null;
  } | null;
};
export type variantsQuery = {
  response: variantsQuery$data;
  variables: variantsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "ignoreNoneECommerce",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasProductsApi",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMarketplace",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitiveUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketplace",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSideImageScalingEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "variantsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v0/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(ignoreNoneECommerce:true,status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          (v8/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralSettings",
        "kind": "LinkedField",
        "name": "generalSettings",
        "plural": false,
        "selections": [
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "variantsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v0/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(ignoreNoneECommerce:true,status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralSettings",
        "kind": "LinkedField",
        "name": "generalSettings",
        "plural": false,
        "selections": [
          (v9/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "58b9defb5ecad5a9ed6f0fb7e9d7ec2f",
    "id": null,
    "metadata": {},
    "name": "variantsQuery",
    "operationKind": "query",
    "text": "query variantsQuery {\n  ecommerceSettings {\n    ecommerceName\n    id\n  }\n  salesChannels(status: ACTIVE, ignoreNoneECommerce: true) {\n    id\n    ecommerceSettings {\n      ecommerceID\n      ecommerceName\n      hasProductsApi\n      isMarketplace\n      remoteUrl\n      definitiveUrl\n      id\n    }\n  }\n  seller {\n    marketplace\n    id\n  }\n  generalSettings {\n    isSideImageScalingEnabled\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "526a10a1dc2aba043312ff2630ed1894";

export default node;
